/**
 * -----------------------------------------------------------------------------------------------------------
 * gs table module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_TABLE_DATA = 'SET_TABLE_DATA'
export const SET_TABLE_DATAS = 'SET_TABLE_DATAS'
export const SET_TABLE_PAGINATION = 'SET_TABLE_PAGINATION'
export const SET_TABLE_PAGINATIONS = 'SET_TABLE_PAGINATIONS'
export const SET_TABLE_QUERIES = 'SET_TABLE_QUERIES'

/**
 * -----------------------------------------------------------------------------------------------------------
 * City module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_CITY = 'GET_ALL_CITY'
export const GET_CITY = 'GET_CITY'
export const GET_BLOCK_CITY = 'GET_BLOCK_CITY'

/**
 * -----------------------------------------------------------------------------------------------------------
 * District module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_DISTRICT = 'GET_ALL_DISTRICT'
export const GET_DISTRICT_TO = 'GET_DISTRICT_TO'
export const GET_DISTRICT_FROM = 'GET_DISTRICT_FROM'
export const SET_LOADED_DISTRICT_BY_CITY_CODE = 'SET_LOADED_DISTRICT_BY_CITY_CODE'
export const GET_DISTRICT_KIND = 'GET_DISTRICT_KIND'
export const SET_LOADED_DISTRICT_BY_CITY_ID = 'SET_LOADED_DISTRICT_BY_CITY_ID'
export const GET_DISTRICT = 'GET_DISTRICT'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Ward module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_WARD = 'GET_ALL_WARD'
export const GET_WARD_TO = 'GET_WARD_TO'
export const GET_WARD_FROM = 'GET_WARD_FROM'
export const SET_LOADED_WARD_BY_DISTRICT_CODE = 'SET_LOADED_WARD_BY_DISTRICT_CODE'
export const SET_LOADED_WARD_BY_DISTRICT_ID = 'SET_LOADED_WARD_BY_DISTRICT_ID'
export const GET_WARD = 'GET_DISTRICT'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Region module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_REGION = 'GET_REGION'
export const GET_ALL_REGIONS = 'GET_ALL_REGIONS'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Carrier module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_CARRIERS = 'GET_ALL_CARRIERS'
export const GET_CARRIER = 'GET_CARRIER'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Service module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_SERVICE = 'GET_ALL_SERVICE'
export const GET_SERVICE = 'GET_SERVICE'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Price table module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_PRICE_TABLE = 'GET_ALL_PRICE_TABLE'
export const SET_PRICE_TABLE_HELPER = 'SET_PRICE_TABLE_HELPER'
export const GET_PRICE_TABLE = 'GET_PRICE_TABLE'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Price table module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_BLOCK = 'SET_BLOCK'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Price table module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_POST_OFFICES = 'SET_POST_OFFICES'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Category table module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES'
export const SET_CATEGORY = 'SET_CATEGORY'
export const CATEGORY_HELPERS = 'CATEGORY_HELPERS'
export const SET_CATEGORIES = 'SET_CATEGORIES'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Blog table module
 * -----------------------------------------------------------------------------------------------------------
 */
export const BLOG_HELPERS = 'BLOG_HELPERS'
export const SET_BLOG = 'SET_BLOG'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Account table module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ACCOUNT = 'GET_ACCOUNT'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Address module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_ALL_ADDRESS = 'GET_ALL_ADDRESS'
export const GET_ADDRESS = 'GET_ADDRESS'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Client module
 * -----------------------------------------------------------------------------------------------------------
 */
export const GET_CLIENT = 'GET_CLIENT'
export const SET_LOADED_CLIENT = 'SET_LOADED_CLIENT'
export const GET_TOTAL_MONEY = 'GET_TOTAL_MONEY'
export const UPDATE_VALUE_CLIENT = 'UPDATE_VALUE_CLIENT'

/**
 * -----------------------------------------------------------------------------------------------------------
 * promotion module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_PROMOTION = 'SET_PROMOTION'
export const SET_PROMOTION_HELPERS = 'SET_PROMOTION_HELPERS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js